import { Component, OnInit, OnDestroy, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms/src/model';
import { SettingsService } from '../../../core/settings/settings.service';
import { CoursModel } from '../../../cours/models/cours.model';
import { StoreService, FormGeneratorService, TableEvent } from '@ngx-resource-toolkit/core';
import { CoursActions } from '../../../cours/models/cours.store';
import { HttpClient } from '@angular/common/http';
import { CoursRechercheModel } from '../../../cours/models/cours-recherche.model';
import { ToasterService } from 'angular2-toaster';
import { ExportService } from '../../services/export.service';
import { professeurFetchOptions, anneeScolaireFetchOptions, inscriptionActionFetchOptions } from '../../resource/select-options';
import { TableButtonsService } from '../../services/table-buttons.service';
import { Subscription } from 'rxjs/Subscription';
import { isOneOfSelectOptionsNull, SelectActions } from '../../resource/select.store';
import { Router } from '@angular/router';
import { TabsService } from '../../services/tabs.service';
import { ErrorMessageService } from '../../services/error-message.service';
import { ModalConfirmationComponent } from '../../miscellaneous/modal-confirmation.component';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

// impossible d'importer CoursSearchComponent sans avoir une staticInjector Error >> la classe est dupliquée de cours/search
// import { CoursSearchComponent } from '../../../cours/search/search.component';

@Component({
  selector: 'app-search-cours',
  templateUrl: './search-component.component.html',
  styleUrls: ['./search-component.component.scss']
})
// ATTENTION Dupliqué de cours/search pour utilisation à l'extérieur du module cours.
export class SearchCoursComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild(ModalConfirmationComponent)

  public selectLoading: boolean = false;
  public loading: boolean = false;
  public exportLoading: boolean = false;
  public  searchForm: FormGroup;
  public coursModel: CoursModel;
  @Input() parametresRechercheInit: Object;
  @Input() searchModel: CoursRechercheModel;
  @Input() tableButtons: any[];
  @Output() coursSelected = new EventEmitter<any>();

  public coursList: CoursModel[];

  public storeSelectSub: Subscription;
  public storeSub: Subscription;

  public confirmationEvent: TableEvent;
  public confirmationMessage: string;
  modalConfirmation: any;

  constructor(
    private settings: SettingsService,
    private store: StoreService,
    private http: HttpClient,
    private toaster: ToasterService,
    private formGenerator: FormGeneratorService,
    private exportService: ExportService,
    private buttonsService: TableButtonsService,
    private router: Router,
    private tabsService: TabsService,
    private errorMessages: ErrorMessageService,
    // private coursSearchComponent: CoursSearchComponent
  ) {

    this.coursModel = new CoursModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log({ ou: 'changes', changes, searchModel: this.searchModel});
    if (changes.parametresRechercheInit) {
      console.log('Changement des paramètres de recherche', changes.parametresRechercheInit.currentValue);
      if (this.searchForm) {
        this.searchForm.patchValue(changes.parametresRechercheInit.currentValue);
        // Modifier this.searchModel plutôt que this.searchForm et appeler initForm
        // this.initForm();
        this.search();
      }
    } else if (changes.searchModel) {
      console.log('searchModel modifié');
      this.initForm();
      this.search();
    }
  }
  // TODO Voir comment détecter les changements dans searchModel pour faire le initForm()
  public initForm() {
    console.log('initForm');
    this.searchForm = this.formGenerator.createFormGroup(this.searchModel, 'search');
    this.initListesDEroulantes();
    /*this.searchModel.registerFormOnChanges(['search'], (value, form) => {
      // console.log('Critere de recherche modifié');
      // Vide les résultats car on a changé un critère de recherche
      console.log('changement detecte', value, form);
    });*/
  }
  initListesDEroulantes() {
    console.log('initListesDEroulantes');
    const professeurId = this.settings.getUserSetting('professeurId');

    this.storeSelectSub = this.store
      .getState(state => state.selectOptions)
      .do(selectOptions => {
        console.log('STATE, selectOptions', {
          selectOptions,
          empty: isOneOfSelectOptionsNull(selectOptions)
        });
        if (isOneOfSelectOptionsNull(selectOptions)) {
          this.store.dispatch(SelectActions.fetch({ http: this.http }));
        }
      })
      .filter(selectOptions => !isOneOfSelectOptionsNull(selectOptions))
      .subscribe(selectOptions => {
        let optionsProfesseurs = [];
        if (professeurId > 0) {
          // Connexion professeur => on limite aux données du professeur (ses élèves...)
          optionsProfesseurs = selectOptions.professeurs.filter(data => {
            return data.value === professeurId;
          });
        } else {
          optionsProfesseurs = [
            { label: 'Tous les professeurs', value: null },
            ...selectOptions.professeurs
          ];
        }
        console.log(
          'optionsProfesseurs',
          optionsProfesseurs,
          optionsProfesseurs.length
        );
        this.searchModel.registerEntriesDynamicProperties(['search'], {
          discipline: {
            options: [
              { label: 'Toutes les disciplines', value: null },
              ...selectOptions.disciplines
            ]
          },
          professeur: {
            options: optionsProfesseurs
            // default: (optionsProfesseurs.length === 1) ? new ProfesseurModel(optionsProfesseurs[0]) : null,
          },
          salle: {
            options: [
              { label: 'Toutes les salles', value: null },
              ...selectOptions.salles
            ]
          },
          cycleCours: {
            options: [
              { label: 'Tous les cycles', value: null },
              ...selectOptions.cycles
            ]
          },
          niveauCours: {
            options: [
              { label: 'Tous les niveaux', value: null },
              ...selectOptions.niveaux
            ]
          }
        });
        if (optionsProfesseurs.length === 1) {
          const idProf = optionsProfesseurs[0].value;
          this.searchForm.patchValue({ professeur: idProf });
        }
      });


      this.http.get(
        anneeScolaireFetchOptions.url,
        anneeScolaireFetchOptions.httpOptions([])
    ).subscribe((data) => {
        const options = anneeScolaireFetchOptions.resMapper(data);
        this.searchModel.registerEntryDynamicProperty(['search'], 'anneeScolaire', 'options', options);
        const anneeScolaireDefault = +this.settings.getUserSetting('anneeScolaire');
        console.log({options, anneeScolaireDefault});
        // tslint:disable-next-line: max-line-length
        // this.searchModel.registerEntryDynamicProperty(['search'], 'anneeScolaire', 'default', anneeScolaireDefault);
        this.searchForm.patchValue({ anneeScolaire: anneeScolaireDefault });
      this.loadCodesActions(anneeScolaireDefault);
    });
  }
  ngOnInit() {
    console.log('init recherche cours (shared)', this.searchModel);
    if (!this.searchModel) {
      this.searchModel = new CoursRechercheModel();
    }

    this.initForm();
    this.initListesDEroulantes();

    this.storeSub = this.store.getState(state => state).subscribe(state => {
      this.loading = state.cours.loading;
      this.selectLoading = state.selectOptions.loading;
      this.coursList = [];

      if (state.cours && state.cours.list instanceof Array) {
        state.cours.list.forEach(cours => {
          this.coursList.push(new CoursModel(cours));
        });
      }
    });

    this.initAbonnementChangementDiscipline();
    this.initAbonnementChangementAnneeScolaire();
    console.log('ngOnInit fin', this.searchModel, this.searchForm);
  }

  initAbonnementChangementAnneeScolaire() {
    console.log('initAbonnementChangementAnneeScolaire');
    this.searchModel.registerEntryDynamicProperty(
      ['search'],
      'anneeScolaire',
      'onChanges',
      (value, form) => {
        const anneeScolaire = value;
        // Si changement année scolire => on recharge la liste des code action (statut inscription)
        this.loadCodesActions(value);
      }
    )
  }
  private loadCodesActions(anneeScolaire) {
    console.log({ anneeScolaire });
    this.searchModel.registerEntryDynamicProperty(
      ['search'],
      'codeAction',
      'hidden',
      !anneeScolaire
    );
    this.http.get(
      inscriptionActionFetchOptions.url,
      { params: { 'params': JSON.stringify(['ref_inscription_action', anneeScolaire]), } }
    ).subscribe((inscriptionAction) => {
      const options = [
        { label: 'Tous', value: null },
        ...inscriptionActionFetchOptions.resMapper(inscriptionAction)
      ];
      this.searchModel.registerEntryDynamicProperty(
        ['search'],
        'codeAction',
        'options',
        options
      );
    })
  }
  initAbonnementChangementDiscipline() {
    this.searchModel.registerEntryDynamicProperty(
      ['search'],
      'discipline',
      'onChanges',
      (value, form) => {
        // Chargement de professeur au changement de discipline
        const professeurId = +this.settings.getUserSetting('professeurId');
        console.log('changement discipline', value, form, professeurId);
        if (!professeurId || professeurId === 0) {
          // console.log('changement discipline => charger liste des professeurs', value, form);
          // on ne recharge pas les professeurs si on est en connexion professeur car il n'y a que le professeur connecté à afficher
          // Astuce à 2 balles car je ne comprends pas (pour le moment)
          // pourquoi on a l'id directement et non un objet contenant l'id et le libellé
          const parametresAUtiliser = JSON.parse(JSON.stringify(form.value));
          parametresAUtiliser.discipline = value;
          console.log('parametresAUtiliser', parametresAUtiliser);
          this.http
            .get(
              professeurFetchOptions.url,
              professeurFetchOptions.httpOptions(parametresAUtiliser)
            )
            .subscribe(data => {
              console.log('changement discipline xx?', data);
              const options = professeurFetchOptions.resMapper(data);
              this.searchModel.registerEntryDynamicProperty(
                ['search'],
                'professeur',
                'default',
                options[0].value
              );
              this.searchModel.registerEntryDynamicProperty(
                ['search'],
                'professeur',
                'options',
                options
              );
              this.searchModel.discipline = value;
              /*this.searchForm = this.formGenerator.createFormGroup(
                this.searchModel,
                'search'
              );*/
              // Faire aussi un patchValue sur le form (liste des profs) car on ne recharge pas forcément le form
              // et le initForm() réinitialise tous les paramètres
              console.log({ searchForm: this.searchForm });
              this.searchForm.controls['professeur'].patchValue({ options: options, default: options[0].value });
            });
        }
      }
    );
  }
  ngOnDestroy() {
    this.storeSub.unsubscribe();
    this.storeSelectSub.unsubscribe();
  }

  majColonnesAffichees() {
    // Afficher la colonne élève et an dans certains cas
    this.coursModel.registerEntryDynamicProperty(
        ['table'],
        'eleveLibelle',
        'hidden',
        this.searchForm.value['uneLigneParEleve'] !== true &&
        this.searchForm.value['typeCours'] !== 1
    );
    this.coursModel.registerEntryDynamicProperty(
        ['table'],
        'nbAnneesDansCycle',
        'hidden',
        this.searchForm.value['uneLigneParEleve'] !== true &&
        this.searchForm.value['typeCours'] !== 1
    );
    // Afficher colonnes Capacité et places dispo ssi recherche cours collectifs ou isUniquementAvecPlacesDisponibles
    const estCoursCollectif = +this.searchForm.value['typeCours'] === 2;
    const isUniquementAvecPlacesDisponibles = +this.searchForm.value['isUniquementAvecPlacesDisponibles'] === 1;
    if (isUniquementAvecPlacesDisponibles) {
      this.searchForm.patchValue({typeCours: 2});
    }
    this.coursModel.registerEntriesDynamicProperties(['table'], {
      nbElevesMax: { hidden: (!estCoursCollectif && !isUniquementAvecPlacesDisponibles) },
      nbPlacesDisponibles: { hidden: (!estCoursCollectif && !isUniquementAvecPlacesDisponibles) },
    });
  }

  search() {
    console.log('shared/cours/search-component', this.searchForm);
    this.filtreUtilisateur();
    this.majColonnesAffichees();
    // Afficher la colonne élève dans certains cas
    this.coursModel.registerEntryDynamicProperty(
      ['table'],
      'eleve',
      'hidden',
      this.searchForm.value['uneLigneParEleve'] !== true &&
      this.searchForm.value['typeCours'] !== 1
    );
    this.store.dispatch(
      CoursActions.search({
        http: this.http,
        model: this.searchModel,
        form: this.searchForm,
        params: [
          this.searchForm.controls['id'].value,
          this.searchForm.controls['anneeScolaire'].value,
        ],
        errorCallback: error => {
          console.log('CoursSearchSharedComponent', 'search error', error);
          this.toaster.pop('error', 'Erreur lors de la recherche de cours');
        }
      })
    );
  }

  exportWrapper(method: string, filenameOnDisk: string) {
    this.exportLoading = true;
    const params = method === 'exportExcel' ? [1] : []; // provenance : 1 = recherche cours
    const callback = function (component) { component.exportLoading = false; };
    this.exportService.exportWrapper(
      this.searchModel,
      this.searchForm.value,
      method,
      filenameOnDisk,
      params,
      null,
      callback,
      this
    );
  }

  exportAsCSV(method: string, filenameOnDisk: string) {
    this.loading = true;
    const headers = ['Discipline', 'Professeur', 'Salle', 'Jour', 'Horaire', 'Durée', 'Niveau', 'Année'];
    const isColEleve = this.searchForm.value.uneLigneParEleve;
    if (isColEleve) {
      headers.unshift('Elève');
    }
    // const columns: TableColumn[] = []; //this.columns; // || this.dataTable._internalColumns;
    /*const headers =
      columns
        .map((column: TableColumn) => column.name)
        .filter((e) => e && e != 'Actions');  // remove column without name (i.e. falsy value)
    */
    const rows: any[] = this.coursList.map((row) => {
      let r = {};
      if (isColEleve) {
        r['Eleve'] = row['eleveLibelle'];
      }
      r['Discipline'] = row['disciplineLibelle'];
      r['Professeur'] = row['professeurLibelle'];
      r['Salle'] = row['salleLibelle'];
      r['Jour'] = row['jourLibelle'];
      const horaire: number = +row['horaireDebut'];
      r['Horaire'] = horaire == 0 ? '' : new String(Math.floor(horaire / 60)).replace(/^(\d)$/, '0$1') + "H" + new String(horaire % 60).replace(/^(\d)$/, '0$1');
      r['Durée'] = row['duree'];
      r['Niveau'] = row['libelleCycleNiveau'];
      r['Année'] = row['nbAnneesDansCycle'];
      return r;
    });

    const options = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      headers: headers,
      showTitle: false,
      // title: 'Report',
      useBom: true,
      nullToEmptyString: true,
    };
    this.loading = false;
    return new Angular5Csv(rows, filenameOnDisk, options);
  }

  reset() {
    console.log('reset');
    this.searchForm.reset();
    this.searchModel.typeCours = 0;
    this.searchModel.fictif = 0;
    this.searchModel.anneeScolaire = +this.settings.getUserSetting('anneeScolaire');
    this.searchForm = this.formGenerator.createFormGroup(
      this.searchModel,
      'search'
    );
    this.filtreUtilisateur();
    this.majColonnesAffichees();

  }
  /* Ajout des filtres utilisateurs si nécessaire : filtre sur les données du professeur si le user est un professeur */
  private filtreUtilisateur(): void {
    const professeurId = this.settings.getUserSetting('professeurId');
    if (professeurId > 0) {
      // this.searchForm.value['professeur'] = professeurId;
      console.log('cours filtreUtilisateur', this.searchForm);
      this.searchForm.controls['professeur'].patchValue(professeurId);
    }
  }

  onEdit(data: TableEvent) {
    this.clearCacheCours(data);
    this.router.navigate(['/cours/edit', data.row.id]);

    this.tabsService.addTab({
      label: `Cours (${data.row.id})`,
      link: '/cours/edit/' + data.row.id,
      group: 'cours',
      iconClass: 'fa fa-edit'
    });
  }

  onConsult(data: TableEvent) {
    this.clearCacheCours(data);
    this.router.navigate(['/cours/show', data.row.id]);

    this.tabsService.addTab({
      label: `Cours (${data.row.id})`,
      link: '/cours/show/' + data.row.id,
      group: 'cours',
      iconClass: 'fa fa-user'
    });
  }

  onDelete(event: TableEvent) {
    this.confirmationEvent = event;
    this.confirmationMessage = `Voulez-vous supprimer le cours (${
      event.row.id
      }) ?`;
    this.modalConfirmation.modal.open();
  }

  deleteCours(event: TableEvent) {
    this.store.dispatch(
      CoursActions.delete({
        http: this.http,
        model: this.coursModel,
        params: [{ id: event.row.id }],
        successCallback: data => {
          this.tabsService.removeTab({ link: '/cours/show/' + event.row.id, group: 'cours' });
          this.tabsService.removeTab({ link: '/cours/edit/' + event.row.id, group: 'cours' });
          this.modalConfirmation.modal.close();
        },
        errorCallback: error => {
          this.toaster.pop(
            'error',
            this.errorMessages.getCoursCreateMessage(error)
          );
          this.modalConfirmation.modal.close();
        }
      })
    );
  }

  clearCacheCours(data: TableEvent) {
    // Vidage cache pour forcer rechargement
    this.store.dispatch(
      CoursActions.clear({
        id: data.row.id,
        errorCallback: err => {
          console.log('CoursSearchComponent', 'clear error', err);
          this.toaster.pop('error', 'Erreur lors du vidage du cours');
        }
      })
    );
  }

  onSelect(event) {
    console.log('selected', event);
    this.coursSelected.emit(event[0]);
  }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/cours/search-component/search-component.component.ts